import { extendObservable, toJS, observe, observable } from 'mobx'
import { expertApi, userApi } from '@atheneum/api'
import {
  composeLocation,
  composeTitleFromName,
  composeLanguage
} from '@atheneum/api/dist/lib'
import { v4 as uuidv4 } from 'uuid'
import defaultsDeep from 'lodash/defaultsDeep'
import pick from 'lodash/pick'
import uniq from 'lodash/uniq'
import uniqBy from 'lodash/uniqBy'
import forOwn from 'lodash/forOwn'
import chunk from 'lodash/chunk'
import omit from 'lodash/omit'
import { ExpertProcessingStatus } from '../Expert/components/ExpertBulkCreate/helpers/expertProcessingStatus'
import { ExpertOptionField } from '../Expert/components/ExpertBulkCreate/helpers/expertOptionField'
import { ExpertOptionCondition } from '../Expert/components/ExpertBulkCreate/helpers/expertOptionCondition'
import { ExpertFieldOptions } from '../Expert/components/ExpertBulkCreate/helpers/expertFieldOptions'
import {
  FinishProcessingActionEnum,
  sendFinishProcessingMetric
} from '../Expert/components/ExpertBulkCreate/helpers/expertBulkCreate.metrics'
import { sendMetric } from '@atheneum/api/dist/lib'
import hash from 'object-hash'
import _ from 'lodash'

// eslint-disable-next-line no-control-regex
const EMAIL_VALIDATION_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
const PHONE_VALIDATION_REGEX = /^[0-9\-+/\s]*$/
const URL_VALIDATION_REGEX = /^((https?):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i

export default class ExpertBulkCreateStore {
  constructor(staticData, modalStore, growlStore, userStore) {
    extendObservable(this, {
      staticData,
      modalStore,
      growlStore,
      userStore
    })

    // Observable map used to start processing of experts
    this.expertProcessingQueue = observable.map()
    this.processExpertsProgress = observable.map()
    observe(this.expertProcessingQueue, async change => {
      if (change.type === 'add') {
        this.expertFinalizeQueue.set(change.name, {
          expertsToSave: [],
          cancelledExpertTrackingIds: [],
          disableExpertSave: change.newValue.disableExpertSave
        })

        await this.processExperts({
          expertsToProcess: toJS(change.newValue.expertsToProcess),
          processingBulkId: change.name,
          requiredFieldOptions: toJS(change.newValue.requiredFieldOptions),
          confirmFieldOptions: toJS(change.newValue.confirmFieldOptions),
          requestUserInputForValidationFails:
            change.newValue.requestUserInputForValidationFails,
          highlightErrorsOnInitialize:
            change.newValue.highlightErrorsOnInitialize
        })
      }
    })

    // Observable arrays used to track expert processing status from the outside
    this.processingExperts = observable.shallowArray([])

    this.cancelledExperts = observable.shallowArray([])

    this.errorExperts = observable.shallowArray([])

    this.completedExperts = observable.shallowArray([])

    // used to time bulk processing
    this.bulkAddJobStartTime = 0

    // Observable map used to start finalizing of experts
    this.expertFinalizeQueue = observable.map()
    observe(this.expertFinalizeQueue, change => {
      if (change.type === 'add') {
        observe(change.newValue.expertsToSave, cng => {
          if (cng.added.length > 0) {
            const allTrackingIdsInBatch = this.expertProcessingQueue
              .get(change.name)
              .expertsToProcess.map(xprt => xprt.bulkCreateTrackingId)

            if (
              allTrackingIdsInBatch.every(
                e =>
                  change.newValue.cancelledExpertTrackingIds.includes(e) ||
                  change.newValue.expertsToSave.some(
                    k => k.bulkCreateTrackingId === e
                  )
              )
            ) {
              this.finalizeExperts(
                toJS(change.newValue.expertsToSave),
                change.newValue.disableExpertSave,
                change.name
              )
            }
          }
        })

        observe(change.newValue.cancelledExpertTrackingIds, cng => {
          if (cng.added.length > 0) {
            const allTrackingIdsInBatch = this.expertProcessingQueue
              .get(change.name)
              .expertsToProcess.map(xprt => xprt.bulkCreateTrackingId)

            if (
              allTrackingIdsInBatch.every(
                e =>
                  change.newValue.cancelledExpertTrackingIds.includes(e) ||
                  change.newValue.expertsToSave.some(
                    k => k.bulkCreateTrackingId === e
                  )
              )
            ) {
              this.finalizeExperts(
                toJS(change.newValue.expertsToSave),
                change.newValue.disableExpertSave,
                change.name
              )
            }
          }
        })
      }
    })
  }

  /**
   *
   * @param {(experts: expert[]) => {}} functionToRun
   * @returns
   */
  observeProcessingExperts = functionToRun => {
    if (!functionToRun || !(typeof functionToRun == 'function')) {
      throw new Error('Must pass a function as a parameter.')
    }

    return observe(this.processingExperts, async change => {
      if (change.added.length > 0) {
        await functionToRun(change.added)
      }
    })
  }

  observeCancelledExperts = functionToRun => {
    if (!functionToRun || !(typeof functionToRun == 'function')) {
      throw new Error('Must pass a function as a parameter.')
    }

    return observe(this.cancelledExperts, async change => {
      if (change.added.length > 0) {
        await functionToRun(change.added)
      }
    })
  }

  observeErrorExperts = functionToRun => {
    if (!functionToRun || !(typeof functionToRun == 'function')) {
      throw new Error('Must pass a function as a parameter.')
    }

    return observe(this.errorExperts, async change => {
      if (change.added.length > 0) {
        await functionToRun(change.added)
      }
    })
  }

  observeCompletedExperts = functionToRun => {
    if (!functionToRun || !(typeof functionToRun == 'function')) {
      throw new Error('Must pass a function as a parameter.')
    }

    return observe(this.completedExperts, async change => {
      if (change.added.length > 0) {
        await functionToRun(change.added)
      }
    })
  }

  createEmptyExpert() {
    return {
      title: '',
      firstName: '',
      lastName: '',
      originalName: '',
      fullName: '',
      address: {
        id: null,
        city: '',
        state: '',
        countryId: null,
        timezoneId: null,
        phones: [
          {
            phoneTypeId: null,
            phoneNum: ''
          }
        ],
        emails: [{ email: '' }]
      },
      email: '',
      links: [{ professionalLinkUrl: '' }],
      expert: {
        subIndustries: [],
        industryExpertise: '',
        expertIndustryExperience: '',
        hourlyRateCurrencyId: null,
        hourlyRate: null,
        newsletter: false,
        sendSmsReminders: false,
        currentUsGovernmentEmployee: false,
        phoneTypeId: null,
        phoneNum: '',
        expertStatusId: this.staticData.CONST.EXPERT_STATUSES.COLD_PROSPECT,
        linkedinVanityName: ''
      },
      languages: [
        {
          id: '',
          name: '',
          languageToUser: {
            languageId: '',
            languageProficiencyId: ''
          }
        }
      ],
      tags: [],
      cv: {
        experiences: [
          {
            position: {
              id: null,
              name: ''
            },
            company: {
              id: null,
              name: ''
            },
            location: '',
            startDate: null,
            endDate: null,
            current: false,
            description: ''
          }
        ],
        cvSource: null
      },
      experiences: [
        {
          position: {
            id: null,
            name: ''
          },
          company: {
            id: null,
            name: ''
          },
          location: '',
          startDate: null,
          endDate: null,
          current: false,
          description: ''
        }
      ],
      country: '',
      linkedinVanityName: ''
    }
  }

  mergeExpertEmails(expert) {
    const allEmails = []

    // Handling for created experts
    if (expert.email) {
      allEmails.push(expert.email)
    }
    if (Array.isArray(expert.address?.emails)) {
      allEmails.push(
        ...expert.address.emails.map(e => e.email.trim()).filter(e => e)
      )
    }

    // Remove duplicate emails
    const allExpertEmails = Array.from(new Set(allEmails).values())

    return allExpertEmails
  }

  fixupExpertData(expert) {
    // Fill in full name if missing
    if (!expert.fullName && (expert.firstName || expert.lastName)) {
      expert.fullName = `${expert.firstName} ${expert.lastName}`.trim()
    }

    // Some experts have a link inserted into db with professionalLinkUrl as null, this causes issue further on. Removing those entries
    expert.links.forEach(link => {
      if (link.professionalLinkUrl === null) {
        link.professionalLinkUrl = ''
      }
    })

    // Make sure experience formatting is correct for the form
    expert.experiences.forEach(experience => {
      // Empty string casues errors on backend validation, use null instead
      if (!experience.endDate) {
        experience.endDate = null
      }

      if (!experience.startDate) {
        experience.startDate = null
      }

      if (experience.position) {
        if (typeof experience.position === 'string') {
          experience.position = {
            id: experience.position,
            name: experience.position
          }
        } else {
          if (!experience.position.id) {
            experience.position.id = experience.position.name
          }
        }
      } else {
        experience.position = {
          id: null,
          name: ''
        }
      }

      if (experience.company) {
        if (typeof experience.company === 'string') {
          experience.company = {
            id: experience.company,
            name: experience.company
          }
        } else {
          if (!experience.company.id) {
            experience.company.id = experience.company.name
          }
        }
      } else {
        experience.company = {
          id: null,
          name: ''
        }
      }
    })

    // Sometimes there is dirty data and current/endDate are both set, which fails validation
    expert.experiences.forEach((experience, experienceIndex) => {
      if (experience.current && experience.endDate) {
        // Set current as false, if endDate is set it means it's not current
        experience.current = false
      }
    })

    return expert
  }

  prepareExpertForProcessing(expert) {
    const expertInputCopy = JSON.parse(JSON.stringify(expert))

    // defaultsDeep doesn't copy if null
    if (expert.cv === null) {
      expert.cv = undefined
    }

    // defaultsDeep doesn't copy if null
    if (expert.cv && expert.cv.experiences === null) {
      expert.cv.experiences = undefined
    }

    let initialExpertValues = defaultsDeep(expert, this.createEmptyExpert())

    // Email mapping
    const allEmails = this.mergeExpertEmails(expert)

    if (allEmails.length > 0) {
      initialExpertValues.email = allEmails[0]
    }

    // Set additional emails
    const additionalEmails = allEmails.filter(
      e => e !== initialExpertValues.email
    )
    if (additionalEmails.length > 0) {
      initialExpertValues.address.emails = additionalEmails.map(e => ({
        email: e
      }))
    } else {
      initialExpertValues.address.emails = [{ email: '' }]
    }

    const links = []
    if (
      initialExpertValues.links &&
      typeof initialExpertValues.links === 'object'
    ) {
      forOwn(initialExpertValues.links, (value, key) => {
        links.push(value)
      })
      initialExpertValues.links = links
    }

    initialExpertValues = pick(toJS(initialExpertValues), [
      'id',
      'bulkCreateTrackingId',
      'bulkCreateCustomIdentifier', // This is a custom identifier which can be used to differentiate experts once they finish processing, in case the random bulkCreateTrackingId is not enough
      'pdlId',
      'listItemId',
      'listId',
      'title',
      'firstName',
      'lastName',
      'originalName',
      'fullName',
      'address.city',
      'address.countryId',
      'address.emails',
      'address.phones',
      'address.state',
      'address.timezoneId',
      'address.id',
      'email',
      'links',
      'expert.subIndustries',
      'languages',
      'tags',
      'expert.industryExpertise',
      'expert.expertIndustryExperience',
      'expert.hourlyRateCurrencyId',
      'expert.hourlyRate',
      'expert.newsletter',
      'expert.expertStatusId',
      'expert.sendSmsReminders',
      'expert.phoneTypeId',
      'expert.phoneNum',
      'expert.currentUsGovernmentEmployee',
      'expert.linkedinVanityName',
      'cv',
      'country',
      'linkedinVanityName',
      'hash'
    ])

    if (
      Array.isArray(expertInputCopy.cv?.experiences) &&
      expertInputCopy.cv.experiences.length > 0
    ) {
      initialExpertValues.experiences = expertInputCopy.cv.experiences
    } else if (
      Array.isArray(expertInputCopy.experiences) &&
      expertInputCopy.experiences.length > 0
    ) {
      initialExpertValues.experiences = expertInputCopy.experiences
    } else {
      initialExpertValues.experiences = initialExpertValues.cv.experiences
    }

    initialExpertValues.experiences.forEach(experience => {
      if (experience.position && typeof experience.position === 'string') {
        experience.position = {
          id: experience.position,
          name: experience.position
        }
      } else if (!experience.position) {
        experience.position = {
          id: null,
          name: ''
        }
      }

      if (experience.company && typeof experience.company === 'string') {
        experience.company = {
          id: experience.company,
          name: experience.company
        }
      } else if (!experience.company) {
        experience.company = {
          id: null,
          name: ''
        }
      }
    })

    // Athena list case:
    // When athena list entries are manually created, company and position are not correctly filled
    if (
      !initialExpertValues.experiences[0].company.id &&
      initialExpertValues.company
    ) {
      initialExpertValues.experiences[0].company.id =
        initialExpertValues.company
      initialExpertValues.experiences[0].company.name =
        initialExpertValues.company
    }

    if (!initialExpertValues.experiences[0].position.id) {
      initialExpertValues.experiences[0].position.id =
        initialExpertValues.position
      initialExpertValues.experiences[0].position.name =
        initialExpertValues.position
    }

    // Empty string casues errors on backend validation, use null instead
    if (!initialExpertValues.expert.hourlyRateCurrencyId) {
      initialExpertValues.expert.hourlyRateCurrencyId = null
    }

    if (initialExpertValues.address.countryId) {
      const foundCountry = this.staticData.countries.find(
        e => e.id === initialExpertValues.address.countryId
      )
      if (foundCountry) {
        initialExpertValues.country = foundCountry.name
      }
    }

    // Make sure subindustry formatting is correct
    expert.expert.subIndustries = expert.expert.subIndustries
      .filter(
        subIndustry =>
          (subIndustry.id || subIndustry.subindustryId) &&
          subIndustry.id !== this.staticData.CONST.SUB_INDUSTRIES.OTHER &&
          subIndustry.subindustryId !==
            this.staticData.CONST.SUB_INDUSTRIES.OTHER &&
          this.staticData.subIndustries.some(
            e => e.id === (subIndustry.id ?? subIndustry.subindustryId)
          )
      )
      .map(subIndustry => {
        const foundSubIndustry = this.staticData.subIndustries.find(
          e => e.id === (subIndustry.id ?? subIndustry.subindustryId)
        )
        return foundSubIndustry
      })

    return initialExpertValues
  }

  /**
   *
   * @param {Object} expert
   * @param {ExpertFieldOptions} expertFieldOptions
   */
  getExpertMissingFields(expert, expertFieldOptions) {
    const missingFieldsResult = []
    if (!expert) {
      throw new Error('expert not supplied')
    }

    if (!(expertFieldOptions instanceof ExpertFieldOptions)) {
      throw new Error(
        'expertFieldOptions is not an instance of ExpertFieldOptions'
      )
    }

    for (let option of expertFieldOptions.fields) {
      if (option instanceof ExpertFieldOptions) {
        missingFieldsResult.push(this.getExpertMissingFields(expert, option))
      } else {
        switch (option) {
          case ExpertOptionField.Title:
            if (expert.title?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.FirstName:
            if (expert.firstName?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.LastName:
            if (expert.lastName?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.OriginalName:
            if (expert.originalName?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.City:
            if (expert.address?.city?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.State:
            if (expert.address?.state?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Country:
            if (expert.address?.countryId) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Timezone:
            if (expert.address?.timezoneId) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Industry:
            if (
              Array.isArray(expert.expert?.subIndustries) &&
              expert.expert?.subIndustries.length > 0
            ) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Language:
            if (
              Array.isArray(expert.languages) &&
              expert.languages.length > 0 &&
              expert.languages.every(
                language =>
                  language.id && language.languageToUser?.languageProficiencyId
              )
            ) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.IndustryExperience:
            if (expert.expert?.industryExpertise?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.ExpertIndustryExperience:
            if (expert.expert?.expertIndustryExperience?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.HourlyRate:
            if (
              expert.expert?.hourlyRate &&
              expert.expert?.hourlyRateCurrencyId
            ) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.WorkExperience:
            // Special case
            expert.experiences.forEach((experience, experienceIndex) => {
              // Validate if there is more than 1 experience OR if one of the fields is specified
              if (
                experience.position?.id ||
                experience.company?.id ||
                experience.startDate ||
                experience.endDate ||
                experience.current ||
                expert.experiences.length > 1
              ) {
                if (
                  !experience.position?.id ||
                  !experience.company?.id ||
                  !experience.startDate ||
                  (!experience.endDate && !experience.current)
                ) {
                  missingFieldsResult.push(ExpertOptionField.WorkExperience)
                }
              }
            })

            if (
              Array.isArray(expert.experiences) &&
              expert.experiences.length > 0 &&
              expert.experiences.every(
                experience =>
                  experience.position?.id &&
                  experience.company?.id &&
                  experience.startDate &&
                  (experience.endDate || experience.current)
              )
            ) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.PhoneNumber:
            if (
              Array.isArray(expert.address?.phones) &&
              expert.address.phones.length > 0 &&
              expert.address.phones.every(
                phone => phone.phoneNum.trim() && phone.phoneTypeId
              )
            ) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Email:
            if (expert.email?.trim()) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Link:
            if (
              Array.isArray(expert.links) &&
              expert.links.length > 0 &&
              expert.links.every(e => e.professionalLinkUrl.trim())
            ) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          case ExpertOptionField.Source:
            if (expert.cv?.cvSource?.id) {
              missingFieldsResult.push(false)
              break
            } else {
              missingFieldsResult.push(option)
              break
            }
          default:
            break
        }
      }
    }

    if (expertFieldOptions.condition === ExpertOptionCondition.And) {
      if (
        missingFieldsResult.some(
          e => (Array.isArray(e) && e.length > 0) || (!Array.isArray(e) && e)
        )
      ) {
        return missingFieldsResult
          .filter(
            e => (Array.isArray(e) && e.length > 0) || (!Array.isArray(e) && e)
          )
          .flat()
      }
    } else if (expertFieldOptions.condition === ExpertOptionCondition.Or) {
      if (
        missingFieldsResult.every(
          e => (Array.isArray(e) && e.length > 0) || (!Array.isArray(e) && e)
        )
      ) {
        return missingFieldsResult
          .filter(
            e => (Array.isArray(e) && e.length > 0) || (!Array.isArray(e) && e)
          )
          .flat()
      }
    } else {
      throw new Error('Invalid condition supplied.')
    }

    return []
  }

  async validateExpert(
    expert,
    expertFieldOptions,
    allExperts,
    runLongLastingValidation = false
  ) {
    const expertValidationResult = {
      bulkCreateTrackingId: expert.bulkCreateTrackingId,
      bulkCreateCustomIdentifier: expert.bulkCreateCustomIdentifier,
      errorFields: [],
      hasError: false,
      languages: [],
      expert: {},
      address: {
        phones: [],
        emails: []
      },
      experiences: [],
      links: [],
      cv: {}
    }

    if (!expert) {
      throw new Error('expert not supplied')
    }

    if (!(expertFieldOptions instanceof ExpertFieldOptions)) {
      throw new Error(
        'expertFieldOptions is not an instance of ExpertFieldOptions'
      )
    }

    const missingFields = this.getExpertMissingFields(
      expert,
      expertFieldOptions
    )
    expertValidationResult.errorFields.push(...missingFields.filter(e => e))

    if (missingFields.includes(ExpertOptionField.Title)) {
      expertValidationResult.title = 'Title is required.'
    }
    if (missingFields.includes(ExpertOptionField.FirstName)) {
      expertValidationResult.firstName = 'First name is required.'
    }
    if (missingFields.includes(ExpertOptionField.LastName)) {
      expertValidationResult.lastName = 'Last name is required.'
    }
    if (missingFields.includes(ExpertOptionField.OriginalName)) {
      expertValidationResult.originalName = 'Original name is required.'
    }
    if (missingFields.includes(ExpertOptionField.City)) {
      expertValidationResult.address.city = 'City is required.'
    }
    if (missingFields.includes(ExpertOptionField.State)) {
      expertValidationResult.address.state = 'State is required.'
    }
    if (missingFields.includes(ExpertOptionField.Country)) {
      expertValidationResult.address.countryId = 'Country is required.'
    }
    if (missingFields.includes(ExpertOptionField.Timezone)) {
      expertValidationResult.address.timezoneId = 'Timezone is required.'
    }
    if (missingFields.includes(ExpertOptionField.Industry)) {
      expertValidationResult.expert.subIndustries =
        'At least one subindustry is required.'
    } else if (
      expert.expert.subIndustries.some(
        e => e.id === this.staticData.CONST.SUB_INDUSTRIES.OTHER
      )
    ) {
      // SubIndustry other is not allowed
      expertValidationResult.expert.subIndustries =
        "SubIndustry 'Other' is not allowed."
      expertValidationResult.errorFields.push(ExpertOptionField.Industry)
    }
    if (missingFields.includes(ExpertOptionField.Language)) {
      expert.languages.forEach((language, languageIndex) => {
        expertValidationResult.languages[languageIndex] = {}
        if (!language.id) {
          expertValidationResult.languages[languageIndex].id =
            'Language is required.'
        }
        if (!language.languageToUser?.languageProficiencyId) {
          expertValidationResult.languages[languageIndex].languageToUser = {}
          expertValidationResult.languages[
            languageIndex
          ].languageToUser.languageProficiencyId =
            'Language proficiency is required.'
        }
      })
    } else {
      expert.languages.forEach((language, languageIndex) => {
        if (
          expert.languages.filter(
            e => e.id && language.id && e.id === language.id
          ).length > 1
        ) {
          expertValidationResult.languages[languageIndex].id =
            'Duplicate languages are not allowed.'
          expertValidationResult.errorFields.push(ExpertOptionField.Language)
        }
      })
    }
    if (missingFields.includes(ExpertOptionField.IndustryExperience)) {
      expertValidationResult.expert.industryExpertise =
        'Industry experience is required.'
    }
    if (missingFields.includes(ExpertOptionField.ExpertIndustryExperience)) {
      expertValidationResult.expert.expertIndustryExperience =
        'Expert industry experience is required.'
    }
    if (missingFields.includes(ExpertOptionField.HourlyRate)) {
      if (!expert.expert?.hourlyRateCurrencyId) {
        expertValidationResult.expert.hourlyRateCurrencyId =
          'Currency is required.'
      }
      if (!expert.expert?.hourlyRate) {
        expertValidationResult.expert.hourlyRate = 'Hourly rate is required.'
      }
    }
    if (expert.expert?.hourlyRate && !Number(expert.expert.hourlyRate)) {
      expertValidationResult.expert.hourlyRate = 'Hourly rate must be a number.'
      expertValidationResult.errorFields.push(ExpertOptionField.HourlyRate)
    }
    if (missingFields.includes(ExpertOptionField.WorkExperience)) {
      expert.experiences.forEach((experience, experienceIndex) => {
        expertValidationResult.experiences[experienceIndex] = {}
        if (!experience.position?.id) {
          expertValidationResult.experiences[experienceIndex].position =
            'Position is required.'
        }
        if (!experience.company?.id) {
          expertValidationResult.experiences[experienceIndex].company =
            'Company is required.'
        }
        if (!experience.startDate) {
          expertValidationResult.experiences[experienceIndex].startDate =
            'Start date is required.'
        }
        if (!experience.endDate && !experience.current) {
          expertValidationResult.experiences[experienceIndex].endDate =
            'End date or current is required.'
        }
      })
    }

    if (missingFields.includes(ExpertOptionField.PhoneNumber)) {
      expert.address.phones.forEach((phone, phoneIndex) => {
        expertValidationResult.address.phones[phoneIndex] = {}
        if (!phone.phoneNum?.trim()) {
          expertValidationResult.address.phones[phoneIndex].phoneNum =
            'Phone number is required.'
        }
        if (!phone.phoneTypeId) {
          expertValidationResult.address.phones[phoneIndex].phoneTypeId =
            'Phone type is required.'
        }
      })
    } else {
      expert.address.phones.forEach((phone, phoneIndex) => {
        expertValidationResult.address.phones[phoneIndex] = {}
        if (phone.phoneNum && !phone.phoneTypeId) {
          // There is an entry with a phone number, but no type defined
          expertValidationResult.address.phones[phoneIndex].phoneTypeId =
            'Phone type is required.'
          expertValidationResult.errorFields.push(ExpertOptionField.PhoneNumber)
        }
        if (phone.phoneNum && !PHONE_VALIDATION_REGEX.test(phone.phoneNum)) {
          //Invalid phone number format
          expertValidationResult.address.phones[phoneIndex].phoneNum =
            "Phone number can contain only digits, '+', '-', ' ' and '/'"
          expertValidationResult.errorFields.push(ExpertOptionField.PhoneNumber)
        }
        if (
          phone.phoneNum &&
          phone.phoneTypeId &&
          expert.address.phones.filter(
            e =>
              e.phoneNum &&
              e.phoneTypeId &&
              e.phoneNum === phone.phoneNum &&
              e.phoneTypeId === phone.phoneTypeId
          ).length > 1
        ) {
          expertValidationResult.address.phones[phoneIndex].phoneNum =
            'Duplicate phone numbers are not allowed.'
          expertValidationResult.errorFields.push(ExpertOptionField.PhoneNumber)
        } else {
          // There might be the same number on one of the other experts in the form
          allExperts.forEach((xprt, xprtIndex) => {
            if (xprt.bulkCreateTrackingId !== expert.bulkCreateTrackingId) {
              if (
                Array.isArray(xprt.address?.phones) &&
                xprt.address.phones.length > 0 &&
                phone.phoneNum &&
                xprt.address.phones.some(e => e.phoneNum === phone.phoneNum)
              ) {
                // We are setting the error only for the current expert in the loop, other experts will have their error set once they run the same check
                expertValidationResult.address.phones[phoneIndex].phoneNum =
                  'Another expert with the same phone number detected in this form.'
                expertValidationResult.errorFields.push(
                  ExpertOptionField.PhoneNumber
                )
              }
            }
          })
        }
      })
    }

    if (missingFields.includes(ExpertOptionField.Email)) {
      expertValidationResult.email = 'Email is required.'
    } else if (expert.email && !EMAIL_VALIDATION_REGEX.test(expert.email)) {
      expertValidationResult.email = 'Invalid email format.'
      expertValidationResult.errorFields.push(ExpertOptionField.Email)
    } else if (expert.email) {
      if (
        Array.isArray(expert.address?.emails) &&
        expert.address?.emails.length > 0 &&
        expert.address.emails.some(e => e.email && e.email === expert.email)
      ) {
        // Check if one of the other emails added is the same
        expertValidationResult.email = 'Duplicate emails are not allowed.'
        expertValidationResult.errorFields.push(ExpertOptionField.Email)
      } else {
        // There might be the same email on one of the other experts in the form
        allExperts.forEach((xprt, xprtIndex) => {
          if (xprt.bulkCreateTrackingId !== expert.bulkCreateTrackingId) {
            if (xprt.email && xprt.email === expert.email) {
              expertValidationResult.email =
                'Another expert with the same email detected in this form.'
              expertValidationResult.errorFields.push(ExpertOptionField.Email)
            }
          }
        })

        if (runLongLastingValidation && !expertValidationResult.email) {
          // Check if some other expert has the same email already set
          const loggedInUser = this.userStore.user
          const emailCheckPayload = { email: expert.email, id: loggedInUser.id }
          const checkEmailResult = await userApi
            .checkEmail(emailCheckPayload)
            .then(({ valid, user }) => {
              return user && user.id === expert.id ? true : valid
            })
            .catch(_ => false)
          if (!checkEmailResult) {
            expertValidationResult.email = 'Email already in use.'
            expertValidationResult.errorFields.push(ExpertOptionField.Email)
          }
        }
      }
    }

    if (
      Array.isArray(expert.address?.emails) &&
      expert.address.emails.length > 0
    ) {
      const loggedInUser = this.userStore.user
      for (const [emailIndex, email] of expert.address.emails.entries()) {
        expertValidationResult.address.emails[emailIndex] = {}
        if (email.email && !EMAIL_VALIDATION_REGEX.test(email.email)) {
          expertValidationResult.address.emails[emailIndex].email =
            'Invalid email format.'
          expertValidationResult.errorFields.push(ExpertOptionField.Email)
        } else if (
          email.email &&
          expert.address.emails.filter(e => e.email && e.email === email.email)
            .length > 1
        ) {
          expertValidationResult.address.emails[emailIndex].email =
            'Duplicate emails are not allowed.'
          expertValidationResult.errorFields.push(ExpertOptionField.Email)
        } else if (email.email) {
          if (expert.email && expert.email === email.email) {
            expertValidationResult.address.emails[emailIndex].email =
              'Duplicate emails are not allowed.'
            expertValidationResult.errorFields.push(ExpertOptionField.Email)
          } else {
            allExperts.forEach((xprt, xprtIndex) => {
              if (xprt.bulkCreateTrackingId !== expert.bulkCreateTrackingId) {
                if (xprt.email && xprt.email === email.email) {
                  expertValidationResult.address.emails[emailIndex].email =
                    'Another expert with the same email detected in this form.'
                  expertValidationResult.errorFields.push(
                    ExpertOptionField.Email
                  )
                } else if (
                  Array.isArray(xprt.address?.emails) &&
                  xprt.address.emails.length > 0 &&
                  xprt.address.emails.find(
                    e => e.email && e.email === email.email
                  )
                ) {
                  expertValidationResult.address.emails[emailIndex].email =
                    'Another expert with the same email detected in this form.'
                  expertValidationResult.errorFields.push(
                    ExpertOptionField.Email
                  )
                }
              }
            })
          }

          if (
            runLongLastingValidation &&
            !expertValidationResult.address.emails[emailIndex].email
          ) {
            const emailCheckPayload = {
              email: email.email,
              id: loggedInUser.id
            }
            const checkEmailResult = await userApi
              .checkEmail(emailCheckPayload)
              .then(({ valid, user }) => {
                return user && user.id === expert.id ? true : valid
              })
              .catch(_ => false)
            if (!checkEmailResult) {
              expertValidationResult.address.emails[emailIndex].email =
                'Email already in use.'
              expertValidationResult.errorFields.push(ExpertOptionField.Email)
            }
          }
        }
      }
    }

    if (missingFields.includes(ExpertOptionField.Link)) {
      expert.links.forEach((link, linkIndex) => {
        expertValidationResult.links[linkIndex] = {}
        if (!link.professionalLinkUrl.trim()) {
          expertValidationResult.links[linkIndex].professionalLinkUrl =
            'Professional link is required.'
        }
      })
    } else {
      expert.links.forEach((link, linkIndex) => {
        expertValidationResult.links[linkIndex] = {}
        if (
          link.professionalLinkUrl.trim() &&
          !URL_VALIDATION_REGEX.test(link.professionalLinkUrl)
        ) {
          expertValidationResult.links[linkIndex].professionalLinkUrl =
            'Invalid URL format.'
          expertValidationResult.errorFields.push(ExpertOptionField.Link)
        }
      })
    }

    if (missingFields.includes(ExpertOptionField.Source)) {
      expertValidationResult.cv.cvSource = 'Source is required.'
    }

    if (expertValidationResult.errorFields.length > 0) {
      expertValidationResult.hasError = true

      expertValidationResult.errorFields = uniq(
        expertValidationResult.errorFields
      )
    }

    return expertValidationResult
  }

  /**
   *
   * @param {Array} expertsToProcess
   * @param {ExpertFieldOptions} expertFieldOptions
   * @returns
   */
  async filterIncompleteExperts(expertsToProcess, expertFieldOptions) {
    const response = {
      incompleteExperts: [],
      validateExpertResults: []
    }

    // Both inputs have to be set
    if (!Array.isArray(expertsToProcess) || expertsToProcess.length === 0) {
      return response
    }

    if (!(expertFieldOptions instanceof ExpertFieldOptions)) {
      throw new Error(
        'expertFieldOptions is not an instance of ExpertFieldOptions'
      )
    }

    const validateExpertPromises = []

    for (let expert of expertsToProcess) {
      if (!response.incompleteExperts.includes(expert)) {
        validateExpertPromises.push(
          this.validateExpert(
            expert,
            expertFieldOptions,
            expertsToProcess,
            true
          )
        )
      }
    }

    response.validateExpertResults = await Promise.all(validateExpertPromises)

    for (let result of response.validateExpertResults) {
      if (result?.hasError) {
        const expert = expertsToProcess.find(
          e => e.bulkCreateTrackingId === result.bulkCreateTrackingId
        )
        response.incompleteExperts.push(expert)
      }
    }

    return response
  }

  /**
   *
   * @param {string} processingBulkId
   * @param {ExpertProcessingStatus} processingStatus
   * @param {string} message
   * @param {{ bulkCreateTrackingId: string,
   * customIdentifier: string,
   * data: object
   * }[]} data
   */
  assignProcessingStatusBulk = (
    processingBulkId,
    processingStatus,
    message,
    data
  ) => {
    if (!processingBulkId?.trim()) {
      throw new Error('processingBulkId is required.')
    }

    if (!processingStatus) {
      throw new Error('Processing status is required.')
    }

    if (!(processingStatus instanceof ExpertProcessingStatus)) {
      throw new Error(
        'Processing status has to be an instance of ExpertProcessingStatus'
      )
    }

    if (!Array.isArray(data) && !data.length) {
      throw new Error('data has to be an Array with items inside')
    }

    switch (processingStatus) {
      case ExpertProcessingStatus.Processing:
        this.processingExperts.push(
          ...data.map(e => ({
            bulkCreateTrackingId: e.bulkCreateTrackingId,
            processingStatus,
            message,
            data: e.data,
            customIdentifier: e.customIdentifier
          }))
        )
        break
      case ExpertProcessingStatus.Completed:
        sendFinishProcessingMetric(FinishProcessingActionEnum.SUCCESS)

        this.completedExperts.push(
          ...data.map(e => ({
            bulkCreateTrackingId: e.bulkCreateTrackingId,
            processingStatus,
            message,
            data: e.data,
            customIdentifier: e.customIdentifier
          }))
        )
        break
      case ExpertProcessingStatus.Cancelled:
        sendFinishProcessingMetric(FinishProcessingActionEnum.DISCARD)

        this.cancelledExperts.push(
          ...data.map(e => ({
            bulkCreateTrackingId: e.bulkCreateTrackingId,
            processingStatus,
            message,
            data: e.data,
            customIdentifier: e.customIdentifier
          }))
        )

        this.expertFinalizeQueue
          .get(processingBulkId)
          .cancelledExpertTrackingIds.push(
            ...data.map(e => e.bulkCreateTrackingId)
          )

        break
      case ExpertProcessingStatus.Error:
        sendFinishProcessingMetric(FinishProcessingActionEnum.FAIL)
        this.errorExperts.push(
          ...data.map(e => ({
            bulkCreateTrackingId: e.bulkCreateTrackingId,
            processingStatus,
            message,
            data: e.data,
            customIdentifier: e.customIdentifier
          }))
        )

        this.expertFinalizeQueue
          .get(processingBulkId)
          .cancelledExpertTrackingIds.push(
            ...data.map(e => e.bulkCreateTrackingId)
          )

        break
      default:
        throw new Error('Unsupported expert processing status used.')
    }
  }

  /**
   *
   * @param {string} bulkCreateTrackingId
   * @param {ExpertProcessingStatus} processingStatus
   * @param {string} message
   */
  assignProcessingStatus = (
    bulkCreateTrackingId,
    processingBulkId,
    processingStatus,
    message,
    data,
    customIdentifier
  ) => {
    if (!bulkCreateTrackingId?.trim()) {
      throw new Error('bulkCreateTrackingId is required.')
    }

    if (!processingBulkId?.trim()) {
      throw new Error('processingBulkId is required.')
    }

    if (!processingStatus) {
      throw new Error('Processing status is required.')
    }

    if (!(processingStatus instanceof ExpertProcessingStatus)) {
      throw new Error(
        'Processing status has to be an instance of ExpertProcessingStatus'
      )
    }

    const dataToPush = {
      bulkCreateTrackingId: bulkCreateTrackingId,
      processingStatus: processingStatus,
      message: message,
      data: data,
      customIdentifier
    }

    switch (processingStatus) {
      case ExpertProcessingStatus.Processing:
        this.processingExperts.push(dataToPush)
        break
      case ExpertProcessingStatus.Completed:
        sendFinishProcessingMetric(FinishProcessingActionEnum.SUCCESS)
        this.completedExperts.push(dataToPush)
        break
      case ExpertProcessingStatus.Cancelled:
        sendFinishProcessingMetric(FinishProcessingActionEnum.DISCARD)
        this.cancelledExperts.push(dataToPush)

        this.expertFinalizeQueue
          .get(processingBulkId)
          .cancelledExpertTrackingIds.push(bulkCreateTrackingId)

        break
      case ExpertProcessingStatus.Error:
        sendFinishProcessingMetric(FinishProcessingActionEnum.FAIL)
        this.errorExperts.push(dataToPush)

        this.expertFinalizeQueue
          .get(processingBulkId)
          .cancelledExpertTrackingIds.push(bulkCreateTrackingId)

        break
      default:
        throw new Error('Unsupported expert processing status used.')
    }
  }

  async autocompleteExperts(expertsToProcess) {
    const expertsMissingLocation = expertsToProcess.filter(
      e =>
        !e.address ||
        !e.address.countryId ||
        !e.address.city ||
        !e.address.state ||
        !e.address.timezoneId ||
        !e.country
    )
    const expertsMissingTitle = expertsToProcess.filter(
      e => !e.title && e.firstName
    )
    const expertsMissingLanguage = expertsToProcess.filter(
      e =>
        !Array.isArray(e.languages) ||
        e.languages.length === 0 ||
        e.languages.every(l => !l.id)
    )

    try {
      if (expertsMissingLocation.length > 0) {
        const composeLocationPromises = []
        for (let expertMissingLocation of expertsMissingLocation) {
          composeLocationPromises.push(
            composeLocation({
              location: expertMissingLocation.address?.address1,
              city: expertMissingLocation.address?.city,
              state: expertMissingLocation.address?.state,
              countryId: expertMissingLocation.address?.countryId,
              timezoneId: expertMissingLocation.address?.timezoneId
            }).then(e => {
              if (!expertMissingLocation.address) {
                expertMissingLocation.address = {}
              }
              expertMissingLocation.address.countryId = e.countryId
              expertMissingLocation.country = e.country?.name
              expertMissingLocation.address.city = e.city
              expertMissingLocation.address.state = e.state
              expertMissingLocation.address.timezoneId = e.timezoneId
            })
          )
        }
        await Promise.all(composeLocationPromises)
      }
    } catch (err) {
      console.error('Error in autocompleteExperts, compose location.')
      console.error(err.message)
    }

    try {
      if (expertsMissingTitle.length > 0) {
        const composedTitles = await composeTitleFromName(
          expertsMissingTitle.map(e => {
            return { firstName: e.firstName, countryId: e.address?.countryId }
          })
        )
        for (let expert of expertsMissingTitle) {
          const title = composedTitles.find(
            e =>
              e.firstName === expert.firstName &&
              e.countryId === expert.countryId
          )
          if (title) {
            expert.title = title.title
          }
        }
      }
    } catch (err) {
      console.error('Error in autocompleteExperts, compose title.')
      console.error(err.message)
    }

    try {
      if (expertsMissingLanguage.length > 0) {
        const composedLanguagePromises = []
        for (let expert of expertsMissingLanguage) {
          composedLanguagePromises.push(
            composeLanguage({
              text: expert.expert.expertIndustryExperience,
              countryId: expert.address.countryId
            }).then(composedLanguages => {
              if (Array.isArray(composedLanguages)) {
                expert.languages = composedLanguages
              }
            })
          )
        }
        await Promise.all(composedLanguagePromises)
      }
    } catch (err) {
      console.error('Error in autocompleteExperts, compose language.')
      console.error(err.message)
    }
  }

  /**
   *
   * @param { Array } expertsToProcess
   * @param { ExpertFieldOptions } requiredFieldOptions
   * @param { ExpertOptionField[] } confirmFieldOptions An array of fields definining what will always be shown in the UI to be checked, no matter if it is required or not
   * @param { boolean } requestUserInputForValidationFails Component will ask for user input if passed validation fails, otherwise it will just return the expert as failed. Default: true
   * @param { boolean } disableExpertSave Component will disable creation and updating of experts and will just return success or fail based on passed validation. This also disables automatic expert creation if expert is not missing any expert creation required fields. Disabling might be useful if custom update/save behaviour is wanted. Default : false
   * @param { boolean } highlightErrorsOnInitialize Whether the components should highlight fields that have an error. Disabling this might be useful for things like creating new experts where the whole form is empty. Default: true
   */
  async addExpertsToProcessingQueue(
    expertsToProcess,
    requiredFieldOptions,
    confirmFieldOptions,
    requestUserInputForValidationFails = true,
    disableExpertSave = false,
    highlightErrorsOnInitialize = true,
    queueId = undefined
  ) {
    if (!Array.isArray(expertsToProcess) || !expertsToProcess.length) {
      return null
    }

    const processingBulkId = queueId ? queueId : uuidv4()

    for (let expert of expertsToProcess) {
      expert.bulkCreateTrackingId = uuidv4()
      this.assignProcessingStatus(
        expert.bulkCreateTrackingId,
        processingBulkId,
        ExpertProcessingStatus.Processing,
        null,
        toJS(expert),
        expert.bulkCreateCustomIdentifier
      )
    }

    if (!(requiredFieldOptions instanceof ExpertFieldOptions)) {
      throw new Error(
        'requiredFieldOptions is not an instance of ExpertFieldOptions'
      )
    }

    if (!Array.isArray(confirmFieldOptions)) {
      confirmFieldOptions = []
    }

    const expertsWithoutId = expertsToProcess.filter(e => !e.id)

    const expertsWithId = expertsToProcess.filter(e => e.id)

    const filteredExpertsWithId = uniqBy(expertsWithId, 'id') // uniqBy removes duplicates if they were passed in, this is sometimes the case if you add multiple experts to AL

    this.expertProcessingQueue.set(processingBulkId, {
      expertsToProcess: [...filteredExpertsWithId, ...expertsWithoutId].map(e =>
        toJS(e)
      ),
      requiredFieldOptions: requiredFieldOptions,
      confirmFieldOptions: confirmFieldOptions,
      requestUserInputForValidationFails: requestUserInputForValidationFails,
      disableExpertSave: disableExpertSave,
      highlightErrorsOnInitialize: highlightErrorsOnInitialize
    })

    // Set extra experts as cancelled
    const filteredOutExpertsWithId = expertsToProcess.filter(
      e =>
        !filteredExpertsWithId.some(
          k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
        )
    )

    for (let expert of filteredOutExpertsWithId) {
      this.assignProcessingStatus(
        expert.bulkCreateTrackingId,
        processingBulkId,
        ExpertProcessingStatus.Cancelled,
        null,
        toJS(expert),
        expert.bulkCreateCustomIdentifier
      )
    }

    return expertsToProcess
  }

  /**
   *
   * @param { Array } expertsToProcess
   * @param { ExpertFieldOptions } requiredFieldOptions
   * @param { ExpertOptionField[] } confirmFieldOptions An array of fields definining what will always be shown in the UI to be checked, no matter if it is required or not
   */
  async processExperts({ expertsToProcess, processingBulkId, ...rest }) {
    const chunks = _.chunk(expertsToProcess, 20)
    for (const [index, chunk] of chunks.entries()) {
      await this.processExpertsChunk({
        expertsToProcess: chunk,
        processingBulkId,
        ...rest
      })
      this.processExpertsProgress.set(
        processingBulkId,
        Math.floor(((index + 1) / chunks.length) * 100)
      )
    }
  }

  async processExpertsChunk({
    expertsToProcess,
    processingBulkId,
    requiredFieldOptions,
    confirmFieldOptions,
    requestUserInputForValidationFails,
    highlightErrorsOnInitialize
  }) {
    // Separate experts into 3 kinds (PDL experts, existing experts, non-existing experts)

    let pdlExpertsInput = expertsToProcess.filter(e => e.id && !Number(e.id))
    let existingExpertsInput = expertsToProcess.filter(
      e => e.id && Number(e.id)
    )
    let nonExistingExpertsInput = expertsToProcess.filter(e => !e.id)

    let pdlExperts = []
    let existingExperts = []
    let nonExistingExperts = []

    /* eslint-disable no-console */
    console.log('------------------------------------')
    console.log('PDL EXPERTS INPUT:')
    console.log(JSON.parse(JSON.stringify(pdlExpertsInput, undefined, 2)))
    console.log('EXISTING EXPERTS INPUT:')
    console.log(JSON.parse(JSON.stringify(existingExpertsInput, undefined, 2)))
    console.log('NON EXISTING EXPERTS INPUT:')
    console.log(
      JSON.parse(JSON.stringify(nonExistingExpertsInput, undefined, 2))
    )
    /* eslint-enable no-console */

    // Step 1: Fetch all PDL experts to get full info on them. Merge Data
    const fullPDLExperts = []
    if (pdlExpertsInput.length > 0) {
      const fetchedPDLExperts = await expertApi.getPDLExperts(
        pdlExpertsInput.map(e => e.id)
      )
      if (Array.isArray(fetchedPDLExperts) && fetchedPDLExperts.length > 0) {
        for (let pdlExpert of fetchedPDLExperts) {
          const matchingInput = pdlExpertsInput.find(e => e.id === pdlExpert.id)
          if (matchingInput) {
            fullPDLExperts.push(defaultsDeep(matchingInput, pdlExpert))
          }
        }
      }

      // It might be possible that some lists have experts which are treated as PDLs that are not actually PDLs
      const nonFetchedExperts = pdlExpertsInput.filter(
        e => !fetchedPDLExperts.some(k => k.id === e.id)
      )

      if (nonFetchedExperts.length > 0) {
        nonExistingExperts.push(
          ...nonFetchedExperts.map(e => ({
            ...e,
            id: undefined,
            pdlId: undefined
          }))
        )
      }
    }

    const pdlPromises = []

    // Step 2: Check if PDL experts are already created into full experts
    fullPDLExperts.forEach(pdlExpert => {
      pdlPromises.push(
        (async () => {
          const allEmails = this.mergeExpertEmails(pdlExpert)

          const result = await expertApi.checkExpert({
            emails: allEmails.length ? allEmails : undefined,
            fullName: pdlExpert.fullName,
            linkedinVanityName: pdlExpert.linkedinVanityName,
            link: pdlExpert.linkedinVanityName
              ? `https://www.linkedin.com/in/${pdlExpert.linkedinVanityName}`
              : undefined
          })

          if (result && !Array.isArray(result) && Number.parseInt(result.id)) {
            if (existingExpertsInput.some(e => e.id === result.id)) {
              this.assignProcessingStatus(
                pdlExpert.bulkCreateTrackingId,
                processingBulkId,
                ExpertProcessingStatus.Cancelled,
                '',
                pdlExpert,
                pdlExpert.bulkCreateCustomIdentifier
              )
            } else {
              existingExpertsInput.push({
                id: result.id,
                bulkCreateTrackingId: pdlExpert.bulkCreateTrackingId,
                pdlId: pdlExpert.id,
                bulkCreateCustomIdentifier: pdlExpert.bulkCreateCustomIdentifier
              })
            }
          } else {
            pdlExperts.push(pdlExpert)
          }
        })()
      )
    })

    await Promise.allSettled(pdlPromises)

    // Step 3: Check if non existing experts are already created into full experts
    const nonExistingExpertPromises = []

    nonExistingExpertsInput.forEach(nonExistingExpert => {
      nonExistingExpertPromises.push(
        (async () => {
          const allEmails = this.mergeExpertEmails(nonExistingExpert)

          const result = await expertApi.checkExpert({
            emails: allEmails.length ? allEmails : undefined,
            fullName: nonExistingExpert.fullName,
            linkedinVanityName: nonExistingExpert.linkedinVanityName,
            link: nonExistingExpert.linkedinVanityName
              ? `https://www.linkedin.com/in/${nonExistingExpert.linkedinVanityName}`
              : undefined
          })

          // Step 3.1: If non existing experts are already created, add them to existingExpertsInput and remove from nonExistingExperts. Merge Data
          if (result && !Array.isArray(result) && Number.parseInt(result.id)) {
            if (existingExpertsInput.some(e => e.id === result.id)) {
              this.assignProcessingStatus(
                nonExistingExpert.bulkCreateTrackingId,
                processingBulkId,
                ExpertProcessingStatus.Cancelled,
                '',
                nonExistingExpert,
                nonExistingExpert.bulkCreateCustomIdentifier
              )
            } else {
              existingExpertsInput.push({
                id: result.id,
                bulkCreateTrackingId: nonExistingExpert.bulkCreateTrackingId,
                bulkCreateCustomIdentifier:
                  nonExistingExpert.bulkCreateCustomIdentifier
              })
            }
          } else {
            nonExistingExperts.push(nonExistingExpert)
          }
        })()
      )
    })

    await Promise.allSettled(nonExistingExpertPromises)

    // Step 4: Fetch all existing experts to get full info on them. Merge Data
    if (existingExpertsInput.length > 0) {
      const idChunks = chunk(
        existingExpertsInput.map(e => e.id),
        25
      )
      const getManyByIdPromises = []

      for (let chunk of idChunks) {
        getManyByIdPromises.push(expertApi.getManyById(chunk))
      }

      const getManyByIdResults = await Promise.all(getManyByIdPromises)
      const fetchedExistingExperts = getManyByIdResults.flat()

      if (
        Array.isArray(fetchedExistingExperts) &&
        fetchedExistingExperts.length > 0
      ) {
        for (let existingExpert of fetchedExistingExperts) {
          const matchingInput = existingExpertsInput.find(
            e => e.id === existingExpert.id
          )
          if (matchingInput) {
            existingExperts.push(defaultsDeep(existingExpert, matchingInput))
          }
        }
      } else {
        nonExistingExperts.push(
          ...existingExpertsInput.map(e => ({
            ...e,
            id: undefined,
            pdlId: undefined
          }))
        )
      }

      // Possible in case there are indexed experts in Elastic Search which are not on platform
      const nonFetchedExperts = existingExpertsInput.filter(
        e => !fetchedExistingExperts.some(k => k.id === e.id)
      )

      if (nonFetchedExperts.length > 0) {
        nonExistingExperts.push(
          ...nonFetchedExperts.map(e => ({
            ...e,
            id: undefined,
            pdlId: undefined
          }))
        )
      }
    }

    // Prep experts for processing
    pdlExperts = pdlExperts.map(e =>
      this.prepareExpertForProcessing(JSON.parse(JSON.stringify(e)))
    )
    existingExperts = existingExperts.map(e =>
      this.prepareExpertForProcessing(JSON.parse(JSON.stringify(e)))
    )
    nonExistingExperts = nonExistingExperts.map(e =>
      this.prepareExpertForProcessing(JSON.parse(JSON.stringify(e)))
    )

    /* eslint-disable no-console */
    console.log('------------------------------------')
    console.log('PDL EXPERTS:')
    console.log(JSON.parse(JSON.stringify(pdlExperts, undefined, 2)))
    console.log('EXISTING EXPERTS:')
    console.log(JSON.parse(JSON.stringify(existingExperts, undefined, 2)))
    console.log('NON EXISTING EXPERTS:')
    console.log(JSON.parse(JSON.stringify(nonExistingExperts, undefined, 2)))
    /* eslint-enable no-console */

    // Hash existing experts to be able to know which ones need to be updated
    existingExperts = existingExperts.map(e => ({
      ...e,
      hash: hash.MD5(JSON.stringify(e))
    }))

    // Fixup experts
    pdlExperts = pdlExperts.map(e => this.fixupExpertData(e))
    existingExperts = existingExperts.map(e => this.fixupExpertData(e))
    nonExistingExperts = nonExistingExperts.map(e => this.fixupExpertData(e))

    // Step 5: Pass pdlExperts, existingExperts and nonExistingExperts through autocompleteExperts which will auto-fill everything it can
    await Promise.all([
      this.autocompleteExperts(pdlExperts),
      this.autocompleteExperts(existingExperts),
      this.autocompleteExperts(nonExistingExperts)
    ])

    /* eslint-disable no-console*/
    console.log('------------------------------------')
    console.log('PROCESSED PDL EXPERTS:')
    console.log(JSON.parse(JSON.stringify(pdlExperts, undefined, 2)))
    console.log('PROCESSED EXISTING EXPERTS:')
    console.log(JSON.parse(JSON.stringify(existingExperts, undefined, 2)))
    console.log('PROCESSED NON EXISTING EXPERTS:')
    console.log(JSON.parse(JSON.stringify(nonExistingExperts, undefined, 2)))
    /* eslint-enable no-console */

    // Step 6: Pass pdlExperts, existingExperts and nonExistingExperts through filterIncompleteExperts
    const pdlFilterResults = await this.filterIncompleteExperts(
      pdlExperts,
      requiredFieldOptions
    )
    const completePDLExperts = pdlExperts.filter(
      e =>
        !pdlFilterResults.incompleteExperts.find(
          k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
        )
    )

    const incompleteFilterResults = await this.filterIncompleteExperts(
      existingExperts,
      requiredFieldOptions
    )
    const completeExistingExperts = existingExperts.filter(
      e =>
        !incompleteFilterResults.incompleteExperts.find(
          k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
        )
    )

    const existingFilterResults = await this.filterIncompleteExperts(
      nonExistingExperts,
      requiredFieldOptions
    )
    const completeNonExistingExperts = nonExistingExperts.filter(
      e =>
        !existingFilterResults.incompleteExperts.find(
          k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
        )
    )

    /* eslint-disable no-console */
    console.log('------------------------------------')
    console.log('INCOMPLETE PDL EXPERTS:')
    console.log(
      JSON.parse(
        JSON.stringify(pdlFilterResults.incompleteExperts, undefined, 2)
      )
    )
    console.log('INCOMPLETE EXISTING EXPERTS:')
    console.log(
      JSON.parse(
        JSON.stringify(incompleteFilterResults.incompleteExperts, undefined, 2)
      )
    )
    console.log('INCOMPLETE NON EXISTING EXPERTS:')
    console.log(
      JSON.parse(
        JSON.stringify(existingFilterResults.incompleteExperts, undefined, 2)
      )
    )
    /* eslint-enable no-console */

    const expertsRequiringManualInput = []
    const expertsNotRequiringManualInput = []

    if (Array.isArray(confirmFieldOptions) && confirmFieldOptions.length > 0) {
      // Confirm field options are present, ask for user input
      expertsRequiringManualInput.push(
        ...completePDLExperts,
        ...completeExistingExperts,
        ...completeNonExistingExperts,
        ...pdlFilterResults.incompleteExperts,
        ...incompleteFilterResults.incompleteExperts,
        ...existingFilterResults.incompleteExperts
      )
    } else {
      if (requestUserInputForValidationFails) {
        // We are asking for user input
        expertsRequiringManualInput.push(
          ...pdlFilterResults.incompleteExperts,
          ...incompleteFilterResults.incompleteExperts,
          ...existingFilterResults.incompleteExperts
        )
      } else {
        // We are not asking for user input, auto cancel expert processing
        for (let expert of [
          ...pdlFilterResults.incompleteExperts,
          ...incompleteFilterResults.incompleteExperts,
          ...existingFilterResults.incompleteExperts
        ]) {
          this.assignProcessingStatus(
            expert.bulkCreateTrackingId,
            processingBulkId,
            ExpertProcessingStatus.Cancelled,
            '',
            toJS(expert),
            expert.bulkCreateCustomIdentifier
          )
        }
      }

      // These experts passed validation, not requiring manual input
      expertsNotRequiringManualInput.push(
        ...completePDLExperts,
        ...completeExistingExperts,
        ...completeNonExistingExperts
      )
    }

    const mergedValidationResult = [
      ...pdlFilterResults.validateExpertResults,
      ...incompleteFilterResults.validateExpertResults,
      ...existingFilterResults.validateExpertResults
    ]
    const initialValidationErrors = []
    for (let expertRequiringManualInput of expertsRequiringManualInput) {
      const matchedValidation = mergedValidationResult.find(
        validation =>
          validation.bulkCreateTrackingId ===
          expertRequiringManualInput.bulkCreateTrackingId
      )
      initialValidationErrors.push(matchedValidation)
    }

    // Step 7: finalize complete experts (This should update existing experts, convert pdl experts and create non existing experts)
    this.expertFinalizeQueue
      .get(processingBulkId)
      .expertsToSave.push(...expertsNotRequiringManualInput)

    // Step 8: Any incomplete experts have to go through manual updates
    if (expertsRequiringManualInput.length > 0) {
      const modalProps = {
        expertsToProcess: expertsRequiringManualInput,
        processingBulkId: processingBulkId,
        requiredFieldOptions: toJS(requiredFieldOptions),
        confirmFieldOptions: toJS(confirmFieldOptions),
        highlightErrorsOnInitialize: highlightErrorsOnInitialize,
        initialValidationErrors: initialValidationErrors
      }

      if (this.bulkAddJobStartTime) {
        const duration = new Date().getTime() - this.bulkAddJobStartTime
        sendMetric(
          'bulkAddExpertsShowBulkCreateDlgTime',
          window.location.hostname,
          {},
          duration
        )
        sendMetric(
          'bulkAddExpertsShowBulkCreateDlgRate',
          window.location.hostname,
          {},
          duration / expertsRequiringManualInput.length
        )
      }

      this.modalStore.show({
        type: 'EXPERT_BULK_CREATE',
        props: modalProps
      })
    }
  }

  async prepareExpertForFinalize(expertsToProcess) {
    if (!expertsToProcess) {
      return
    }

    for (let expert of expertsToProcess) {
      if (
        expert.hash &&
        expert.hash !== hash.MD5(JSON.stringify(omit(expert, ['hash'])))
      ) {
        expert.hash = undefined
        expert.updateRequired = true
      }
    }

    expertsToProcess.forEach(e => {
      if (
        Array.isArray(e.address?.emails) &&
        e.address.emails.every(k => !k.email)
      ) {
        e.address.emails = []
      }

      e.languages = e.languages.filter(lang => lang.id)

      // Empty string causes error on creation as DB validates two empty strings as equal
      if (!e.expert.linkedinVanityName) {
        e.expert.linkedinVanityName = undefined
      }
    })
  }

  /**
   *
   * @param {Array} expertsToProcess
   * @param {Number} addToListId
   * @param {Number} addToProjectId
   */
  async finalizeExperts(expertsToProcess, disableExpertSave, processingBulkId) {
    if (!Array.isArray(expertsToProcess) || expertsToProcess.length < 1) {
      return
    }

    await this.prepareExpertForFinalize(expertsToProcess)

    const pdlExperts = expertsToProcess.filter(e => e.id && !Number(e.id))
    const existingExperts = expertsToProcess.filter(e => e.id && Number(e.id))
    const nonExistingExperts = expertsToProcess.filter(e => !e.id)

    const dataToReturn = []

    if (pdlExperts.length > 0) {
      //const pdlExpertPromises = []

      const pdlFilterResults = await this.filterIncompleteExperts(
        pdlExperts,
        ExpertFieldOptions.EXPERT_CREATION_OPTIONS
      )
      const completePDLExperts = pdlExperts.filter(
        e =>
          !pdlFilterResults.incompleteExperts.find(
            k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
          )
      )

      for (let expert of pdlFilterResults.incompleteExperts) {
        dataToReturn.push({
          data: toJS(expert),
          customIdentifier: expert.bulkCreateCustomIdentifier,
          bulkCreateTrackingId: expert.bulkCreateTrackingId
        })
      }

      for (let expert of completePDLExperts) {
        if (disableExpertSave) {
          dataToReturn.push({
            data: toJS(expert),
            customIdentifier: expert.bulkCreateCustomIdentifier,
            bulkCreateTrackingId: expert.bulkCreateTrackingId
          })
        } else {
          await expertApi
            .create(expert)
            .then(e => {
              dataToReturn.push({
                data: { ...toJS(e), pdlId: expert.id },
                bulkCreateTrackingId: expert.bulkCreateTrackingId,
                customIdentifier: expert.bulkCreateCustomIdentifier
              })
            })
            .catch(e => {
              this.assignProcessingStatus(
                expert.bulkCreateTrackingId,
                processingBulkId,
                ExpertProcessingStatus.Error,
                e ? e.message : 'Unknown error',
                toJS(expert),
                expert.bulkCreateCustomIdentifier
              )
            })
        }
      }

      //await Promise.all(pdlExpertPromises)
    }

    if (existingExperts.length > 0) {
      //const existingExpertPromises = []

      const existingFilterResults = await this.filterIncompleteExperts(
        existingExperts,
        ExpertFieldOptions.EXPERT_CREATION_OPTIONS
      )
      const completeExistingExperts = existingExperts.filter(
        e =>
          !existingFilterResults.incompleteExperts.find(
            k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
          )
      )

      for (let expert of existingFilterResults.incompleteExperts) {
        dataToReturn.push({
          data: toJS(expert),
          bulkCreateTrackingId: expert.bulkCreateTrackingId,
          customIdentifier: expert.bulkCreateCustomIdentifier
        })
      }

      for (let expert of completeExistingExperts) {
        if (disableExpertSave || !expert.updateRequired) {
          dataToReturn.push({
            data: toJS(expert),
            bulkCreateTrackingId: expert.bulkCreateTrackingId,
            customIdentifier: expert.bulkCreateCustomIdentifier
          })
        } else {
          await expertApi
            .updateV2(expert.id, expert)
            .then(e => {
              dataToReturn.push({
                data: { ...toJS(e), pdlId: expert.pdlId },
                bulkCreateTrackingId: expert.bulkCreateTrackingId,
                customIdentifier: expert.bulkCreateCustomIdentifier
              })
            })
            .catch(e => {
              this.assignProcessingStatus(
                expert.bulkCreateTrackingId,
                processingBulkId,
                ExpertProcessingStatus.Error,
                e ? e.message : 'Unknown error',
                toJS(expert),
                expert.bulkCreateCustomIdentifier
              )
            })
        }
      }

      //await Promise.all(existingExpertPromises)
    }

    if (nonExistingExperts.length > 0) {
      //const nonExistingExpertPromises = []

      const nonExistingFilterResults = await this.filterIncompleteExperts(
        nonExistingExperts,
        ExpertFieldOptions.EXPERT_CREATION_OPTIONS
      )
      const completeNonExistingExperts = nonExistingExperts.filter(
        e =>
          !nonExistingFilterResults.incompleteExperts.find(
            k => k.bulkCreateTrackingId === e.bulkCreateTrackingId
          )
      )

      for (let expert of nonExistingFilterResults.incompleteExperts) {
        dataToReturn.push({
          data: toJS(expert),
          bulkCreateTrackingId: expert.bulkCreateTrackingId,
          customIdentifier: expert.bulkCreateCustomIdentifier
        })
      }

      for (let expert of completeNonExistingExperts) {
        if (disableExpertSave) {
          dataToReturn.push({
            data: toJS(expert),
            bulkCreateTrackingId: expert.bulkCreateTrackingId,
            customIdentifier: expert.bulkCreateCustomIdentifier
          })
        } else {
          await expertApi
            .create(expert)
            .then(e => {
              dataToReturn.push({
                data: { ...toJS(e) },
                bulkCreateTrackingId: expert.bulkCreateTrackingId,
                customIdentifier: expert.bulkCreateCustomIdentifier
              })
            })
            .catch(e => {
              this.assignProcessingStatus(
                expert.bulkCreateTrackingId,
                processingBulkId,
                ExpertProcessingStatus.Error,
                e ? e.message : 'Unknown error',
                toJS(expert),
                expert.bulkCreateCustomIdentifier
              )
            })
        }
      }

      //await Promise.all(nonExistingExpertPromises)
    }

    if (dataToReturn.length) {
      this.assignProcessingStatusBulk(
        processingBulkId,
        ExpertProcessingStatus.Completed,
        '',
        dataToReturn
      )
    }
  }
}
